import React from "react";
import "./testimonial.css";
import { Container, Row, Col } from "reactstrap";
import Slider from "react-slick";

import img from "../../assests/images/testimonial01.png";

const Testimonials = () => {
  const settings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
  };
  return (
    <section>
      <Container>
        <Row>
          <Col lg="10" md="12" className="m-auto">
            <div className="testimonial__wrapper d-flex justify-content-between align-items-center ">
              <div className="testimonial__img w-50">
                <img src={img} alt="" className="w-100" />
              </div>

              <div className="testimonial__content w-50">
                <h2 className="mb-4">Our Students Voice</h2>

                <Slider {...settings}>
                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                        Excellent course of materials
                      </h6>
                      <p>
                      Fantastic Android online class! The interactive sessions and real-world projects made learning enjoyable. The instructor's clear explanations and constant support helped me grasp complex concepts easily.
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold">Somnath Ghutukade</h6>
                        <p>AGCE,satara</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                      Outstanding React.js course!                       </h6>
                      <p>
                     The hands-on approach and well-structured curriculum allowed me to quickly grasp React concepts. The engaging projects helped solidify my skills, and the instructor's guidance was invaluable. I feel confident in my React abilities and am eager to apply them in real-world projects. A top-notch learning experience!
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold">Pooja Jagtap</h6>
                        <p>Pune, Maharashtra</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="single__testimonial">
                      <h6 className="mb-3 fw-bold">
                      Exceptional C and C++ course!                      </h6>
                      <p>
                      The comprehensive content, coupled with practical coding exercises, provided a solid foundation. The instructor's clarity and responsiveness made complex topics understandable. 
                      </p>

                      <div className="student__info mt-4">
                        <h6 className="fw-bold">Anil Salunkhe</h6>
                        <p>Mumbai, Maharashtra</p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;
